export enum SenderSourceType {
  USERS_PHONE = 'USERS_PHONE',
  REPLY_PHONE = 'REPLY_PHONE',
  SENDER_ID = 'SENDER_ID',
  INBOUND = 'INBOUND',

  USER_CARRIER_TWILIO = 'USER_CARRIER_TWILIO',
  USER_CARRIER_VONAGE = 'USER_CARRIER_VONAGE',
  USER_CARRIER_BANDWIDTH = 'USER_CARRIER_BANDWIDTH',
  USER_CARRIER_SINCH = 'USER_CARRIER_SINCH',
  USER_CARRIER_INFOBIP = 'USER_CARRIER_INFOBIP', // presumed name
  USER_CARRIER_MESSAGE_BIRD = 'USER_CARRIER_MESSAGE_BIRD',
  USER_CARRIER_AWS = 'USER_CARRIER_AWS', // presumed name
  USER_CARRIER_TELNYX = 'USER_CARRIER_TELNYX',

  USER_CARRIER_TWILIO_SENDER_ID = 'USER_CARRIER_TWILIO_SENDER_ID',
  USER_CARRIER_VONAGE_SENDER_ID = 'USER_CARRIER_VONAGE_SENDER_ID', // presumed name
  USER_CARRIER_BANDWIDTH_SENDER_ID = 'USER_CARRIER_BANDWIDTH_SENDER_ID', // presumed name
  USER_CARRIER_SINCH_SENDER_ID = 'USER_CARRIER_SINCH_SENDER_ID', // presumed name
  USER_CARRIER_INFOBIP_SENDER_ID = 'USER_CARRIER_INFOBIP_SENDER_ID', // presumed name
  USER_CARRIER_MESSAGE_BIRD_SENDER_ID = 'USER_CARRIER_MESSAGE_BIRD_SENDER_ID', // presumed name
  USER_CARRIER_AWS_SENDER_ID = 'USER_CARRIER_AWS_SENDER_ID', // presumed name
  USER_CARRIER_TELNYX_SENDER_ID = 'USER_CARRIER_TELNYX_SENDER_ID', // presumed name
}

export enum SenderSourceRegistrationStatus {
  REGISTERED = 'Registered',
  NOT_REGISTERED = 'Not registered',
  IN_REVIEW = 'In review',
  ACTION_REQUIRED = 'Action required',
  FAILED = 'Failed',
}

export enum SenderSourceRegistrationType {
  tollFree = 'tollfree',
  tenDlc = 'tendlc',
}

export interface SenderSourceRegistration {
  registrationStatus: SenderSourceRegistrationStatus
  type: SenderSourceRegistrationType
}
